import React, { useEffect, useState } from 'react'
import RouteModal from '../../../../Component/BasicComponents/Modal/RouteModal';
import CustomInput from '../../../../Component/BasicComponents/CustomInput';
import ReusableDropdown from '../../../../Component/BasicComponents/Dropdowns/RouteDropdown';
import { Btn } from '../../../../AbstractElements';
import { toast } from 'react-toastify';
import { useAddSubscriberFields, useGetStatusOptionsData, useGetSurveyQuestionTypesData, useUpdateSubscriberFields } from '../hooks/useSubscriber';

type ProductCardProps = {
    setIsModalOpen?: any;
    isModalOpen?: any;
    toggleModal?: any;
    title?: any;
    checkAddEditStatus?: any;
    setCheckAddEditStatus?: any;
    SubscriberTypeId?: number | any;
    rowData?: any;
};
const SubscriberFieldsAddAndEditModal: React.FC<ProductCardProps> = ({ rowData, SubscriberTypeId, setIsModalOpen, isModalOpen, title, checkAddEditStatus, setCheckAddEditStatus }) => {
    const { data: fieldsData } = useGetSurveyQuestionTypesData({ enable: true })
    const { data: statusOptions } = useGetStatusOptionsData({ enable: true })
    const [modalValues, setModalValues] = useState<any>({
        FieldName: '',
        FieldType: '',
        FieldOptions: '',
        FieldDefault: '',
        IsActive: '0',
    })
    const { mutate } = useAddSubscriberFields();
    const { mutate: updateMutate } = useUpdateSubscriberFields();

    const handleClose = () => {
        setIsModalOpen(false);
        setCheckAddEditStatus('');
        setModalValues((prevState: any) => ({ ...prevState, FieldName: '', FieldType: '', FieldOptions: '', FieldDefault: '', IsActive: '0' }))
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!modalValues?.FieldType) {
            toast.warn("Please select field type.");
            return;
        }

        const body = {
            SubscriberTypeId: SubscriberTypeId,
            FieldName: modalValues?.FieldName,
            FieldType: modalValues?.FieldType,
            FieldOptions: modalValues?.FieldOptions,
            FieldDefault: modalValues?.FieldDefault,
            IsActive: modalValues?.IsActive
        };
        if (checkAddEditStatus === "Add") {
            mutate(body, {
                onSuccess: () => {
                    handleClose();
                },
            });
        } else {
            updateMutate(
                { id: Number(rowData?.SubscriberFieldId), body },
                {
                    onSuccess: () => {
                        handleClose();
                    },
                }
            );
        }
    };

    useEffect(() => {
        if (checkAddEditStatus === 'Edit') {
            setModalValues((prevState: any) => ({ ...prevState, SubscriberTypeId: SubscriberTypeId, FieldName: rowData?.FieldName, FieldType: rowData?.FieldType, FieldOptions: rowData?.FieldOptions, FieldDefault: rowData?.FieldDefault, IsActive: rowData?.IsActive == true ? '1' : '0' }))
        }
    }, [checkAddEditStatus])
    return (
        <RouteModal
            isOpen={isModalOpen}
            toggle={() => { setIsModalOpen(!isModalOpen); setModalValues((prevState: any) => ({ ...prevState, FieldName: '', FieldType: '', FieldOptions: '', FieldDefault: '', IsActive: '0' })); }}
            title={title}
            // title="Add MTP"
            size="md"
            content={
                <form onSubmit={handleSubmit}>
                    <div className="row mb-0">
                        <div className="d-flex justify-content-start gap-2">
                            <CustomInput
                                placeholder="Field Name"
                                disabled={false}
                                onChange={(e: any) => { setModalValues((prevState: any) => ({ ...prevState, FieldName: e.target.value })); }}
                                value={modalValues?.FieldName}
                                required={true}
                                label="Field Name*"
                                style={{
                                    border: "1px solid #EDEDED",
                                    borderRadius: "4px",
                                    padding: "10px",
                                    fontSize: "14px",
                                    backgroundColor: "#fff",
                                }}
                            />
                            <ReusableDropdown
                                options={fieldsData?.data || []}
                                value={modalValues?.FieldType}
                                onChange={(value: any) => {
                                    setModalValues((prevState: any) => ({ ...prevState, FieldType: value }));

                                }}
                                DropdownHeading="Field Type*"
                            />
                        </div>
                        <CustomInput
                            placeholder="Field Options"
                            disabled={false}
                            onChange={(e: any) => { setModalValues((prevState: any) => ({ ...prevState, FieldOptions: e.target.value })); }}
                            value={modalValues?.FieldOptions}
                            label="Field Options"
                            style={{
                                border: "1px solid #EDEDED",
                                borderRadius: "4px",
                                padding: "10px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                            }}
                        />
                        <div className="d-flex justify-content-start gap-2">
                            <CustomInput
                                placeholder="Default Value"
                                disabled={false}
                                onChange={(e: any) => { setModalValues((prevState: any) => ({ ...prevState, FieldDefault: e.target.value })); }}
                                value={modalValues?.FieldDefault}
                                // required={true}
                                label="Default Value"
                                style={{
                                    border: "1px solid #EDEDED",
                                    borderRadius: "4px",
                                    padding: "10px",
                                    fontSize: "14px",
                                    backgroundColor: "#fff",
                                }}
                            />
                            <ReusableDropdown
                                options={statusOptions?.data || []}
                                value={modalValues?.IsActive}
                                onChange={(value: any) => {
                                    setModalValues((prevState: any) => ({ ...prevState, IsActive: value }));
                                }}
                                DropdownHeading="Is Active*"
                            />
                        </div>

                        <div style={{ height: 20 }} />
                        <div className="d-flex justify-content-start gap-2">
                            <Btn
                                style={{ backgroundColor: "#43B9B2", color: "white" }}
                                type="submit"
                            >
                                {checkAddEditStatus === 'Add' ? 'Submit' : 'Update'}
                            </Btn>
                            <Btn
                                style={{
                                    backgroundColor: "#F9FAFC",
                                    color: "#000",
                                    border: "1px solid #E0E0E0",
                                }}
                                type="button"
                                onClick={() => { setIsModalOpen(false); setCheckAddEditStatus(''); setModalValues((prevState: any) => ({ ...prevState, FieldName: '', FieldType: '', FieldOptions: '', FieldDefault: '', IsActive: '0' })) }}
                            >
                                Cancel
                            </Btn>
                        </div>



                    </div>
                </form>
            }
        />
    )
}

export default SubscriberFieldsAddAndEditModal